import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { Nearshore } from '../models/nearshore';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NearshoreService {
  API_URL = `${environment.apiUrl}/nearshores`;
  CACHE_SIZE = 1;
  private cache$!: Observable<Array<Nearshore>>;
  isNearshoreLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  get nearshores() {
    if (!this.cache$) {
      this.cache$ = this.requestNearshores().pipe(shareReplay(this.CACHE_SIZE));
      this.isNearshoreLoading$.next(true);
    }
    this.isNearshoreLoading$.next(false);
    return this.cache$;
  }

  private requestNearshores() {
    return this.http.get<Nearshore[]>(this.API_URL);
  }

  getNearShores(): Observable<Nearshore[]> {
    return this.http.get<Nearshore[]>(this.API_URL).pipe(
      map(nearshores => nearshores.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addNearShore(nearshore: Nearshore): Observable<Nearshore> {
    return this.http.post<Nearshore>(this.API_URL, nearshore);
  }

  updateNearShore(nearshore: Nearshore): Observable<Nearshore> {
    return this.http.put<Nearshore>(`${this.API_URL}/${nearshore.id}`, nearshore);
  }

  deleteNearShore(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
  
}
